import React from "react";

import {
    Backdrop,
    Box,
    Button,
    Stack,
    Typography
} from "@mui/material";
import { Trans } from "@lingui/macro";
import { ShoppingCart } from "@mui/icons-material";
import { Link } from "react-router-dom";

export default class MandatorySubscriptionModal extends React.Component<{}, {}> {

    render() {
        return (<Backdrop
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1
            }}
            open={true}>
            <Box
                style={{
                    border: "2px solid " + process.env.REACT_APP_SECONDARY_COLOR,
                    minWidth: "350px",
                    minHeight: "200px",
                    padding: "25px",
                    textAlign: "center",
                    position: "fixed",
                    bottom: "50%"
                }}>
                <Stack spacing={1}>
                    <Typography variant="h2" color={process.env.REACT_APP_PRIMARY_COLOR}>
                        <Trans id="pm-mandatory-subscription-title">
                            Riservato a utenti abbonati
                        </Trans>
                    </Typography>
                    <Typography variant="body1" color={process.env.REACT_APP_DEFAULT_TEXT_COLOR}>
                        <Trans id="pm-mandatory-subscription-text">
                            Per visionare il contenuto devi sottoscrivere un abbonamento
                        </Trans>
                    </Typography>
                    <Link to="/subscribe">
                        <Button variant="outlined" startIcon={<ShoppingCart />}>
                            <Trans id="pm-modal-subscription">
                                Visualizza piani
                            </Trans>
                        </Button>
                    </Link>
                </Stack>
            </Box>

        </Backdrop>);
    }
}
